import React, { useState } from "react";
import QrReader from "react-qr-reader";
import { getToken } from "@/services/auth";
import { api } from "@/services/api";
import ModalPopup from "@/components/ModalPopup";

import "bootstrap/dist/css/bootstrap-grid.min.css";
import { Container } from "./style";

export const ScanQrCode = () => {
	const [camera, setCamera] = useState(false);
	const [coupon, setCoupon] = useState("");
	const [submitForm, setSubmitForm] = useState(false);
	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});
	const [form, setForm] = useState(false);

	function HandleEnablecamera() {
		let track;

		function getUserMedia(constraints) {
			// if Promise-based API is available, use it
			if (navigator.mediaDevices) {
				return navigator.mediaDevices.getUserMedia(constraints);
			}

			// otherwise try falling back to old, possibly prefixed API...
			var legacyApi =
				navigator.getUserMedia ||
				navigator.webkitGetUserMedia ||
				navigator.mozGetUserMedia ||
				navigator.msGetUserMedia;

			if (legacyApi) {
				// ...and promisify it
				return new Promise(function (resolve, reject) {
					legacyApi.bind(navigator)(constraints, resolve, reject);
				});
			}
		}

		function getStream(type) {
			if (
				!navigator.mediaDevices &&
				!navigator.getUserMedia &&
				!navigator.webkitGetUserMedia &&
				!navigator.mozGetUserMedia &&
				!navigator.msGetUserMedia
			) {
				setModalPopup(true);
				setModalContent({
					title: "Ocorreu um problema!",
					content: "User Media API not supported.",
				});
				return;
			}

			var constraints = {};
			constraints[type] = true;

			getUserMedia(constraints)
				.then(function (stream) {
					track = stream.getTracks()[0];
					setCamera(true);
				})
				.catch(function (err) {
					setModalPopup(true);
					setModalContent({
						title: "Ocorreu um problema!",
						content: "Aviso: Uso da câmera bloqueado ou indisponível",
					});
					setCamera(false);
				});
		}

		getStream("video");

		// desliga a camera ao sair do componente
		return () => {
			if (track) {
				track.stop();
			}
		};
	};

	function handleError(err) {
		console.error(err);
	}

	// validacao de cumpom  por qrcode
	function handleScan(data) {
		if (data) {
			api.post(
				"/merchant/coupons/validate",
				{
					coupon: data,
				},
				{
					headers: {
						Authorization: `Bearer ${getToken()}`,
					},
				},
			)
				.then((res) => {
					if (res.data.status === 200) {
						setModalPopup(true);
						setModalContent({
							title: "Programa Fidelidade GERIOOX",
							content: res.data.message,
						});
					}

					if (res.data.status === 502) {
						setModalPopup(true);
						setModalContent({
							title: "Programa Fidelidade GERIOOX",
							content: res.data.message,
						});
					}

					setCamera(false);
				})
				.catch((error) => {
					console.error({
						endPoint: "/merchant/coupons/validate",
						error,
					});
					setCamera(false);
					setModalPopup(true);
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content:
							"Serviço indisponível tente novamente mais tarde.",
					});
				});
		}
	}

	// validacao de cumpom  por formulario
	function handleSubmit(e) {
		e.preventDefault();
		setSubmitForm(true);

		if (coupon) {
			api.post(
				"/merchant/coupons/validate",
				{
					coupon,
				},
				{
					headers: {
						Authorization: `Bearer ${getToken()}`,
					},
				},
			)
				.then((res) => {
					if (res.data.status === 200) {
						setModalPopup(true);
						setModalContent({
							title: "Programa Fidelidade GERIOOX",
							content: res.data.message,
						});
					}

					if (res.data.status === 401) {
						setModalPopup(true);
						setModalContent({
							title: "Programa Fidelidade GERIOOX",
							content: res.data.message,
						});
					}

					if (res.data.status === 502) {
						setModalPopup(true);
						setModalContent({
							title: "Programa Fidelidade GERIOOX",
							content: res.data.message,
						});
					}

					setSubmitForm(false);
				})
				.catch((error) => {
					console.error({
						endPoint: "/merchant/coupons/validate",
						error,
					});
					setSubmitForm(false);
					setModalPopup(true);
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content:
							"Serviço indisponível tente novamente mais tarde.",
					});
				});
		} else {
			setSubmitForm(false);
			setModalPopup(true);
			setModalContent({
				title: "Programa Fidelidade GERIOOX",
				content: "Informe o número do cupom",
			});
		}
	}

	return (
		<Container>
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(!modalPopup)}
			/>
			<aside className='d-none d-lg-flex'>
				<img
					loading='lazy'
					className='img-responsive'
					src={require("@/assets/img/cachorro@2x.jpg").default}
					alt='cao e gato'
				/>
			</aside>

			<section className='content'>
				<div className='block-message'>
					<p className='block-message__text'>
						Digitalize o código QR, aproximando a câmera do código
						do cliente. <br />{" "}
						<span className="text-primary" onClick={() => setForm(!form)}>Ou clique aqui</span>{" "}
						para digitar o código do cupom.
					</p>
				</div>

				<div className='scan'>
					{camera ? (
						<QrReader
							onError={handleError}
							onScan={handleScan}
							style={{ width: "100%" }}
							enfrentandoMode={"user"}
						/>
					) : (
						<div className='cam-blocked' onClick={HandleEnablecamera}>
							<p>
								Clique aqui e habilite o uso da câmera.
								<br /> Para usar o scan.
							</p>
						</div>
					)}
				</div>

				<form
					className='form'
					onSubmit={handleSubmit}
					style={{ display: form ? "flex" : "none" }}>
					<input
						type='text'
						value={coupon}
						onChange={(e) => setCoupon(e.target.value)}
						placeholder='Insira o número do cupom do cliente'
					/>
					<button
						type='submit'
						className='btn-primary'
						disabled={submitForm ? "disabled" : ""}>
						{submitForm ? "Validando" : "Verificar cupom"}
					</button>
				</form>
			</section>
		</Container>
	);
};

export default ScanQrCode;
